import { render, staticRenderFns } from "./PromotingAppsBanner.vue?vue&type=template&id=516e7dd2&scoped=true&"
import script from "./PromotingAppsBanner.vue?vue&type=script&lang=js&"
export * from "./PromotingAppsBanner.vue?vue&type=script&lang=js&"
import style0 from "./PromotingAppsBanner.vue?vue&type=style&index=0&id=516e7dd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516e7dd2",
  null
  
)

export default component.exports